module.exports = __webpack_public_path__ + "img/logo.b70c8128.png";